
let formatPhoneNumber = (str: string) => {
  let cleaned = ('' + str).replace(/\D/g, '')
  let match = cleaned.match(/[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/gim)
  if (match) {
    let matchParts = match.toString().split('')
    try {
      let result = ['(', matchParts.slice(0, 3).join(""), ') ', matchParts.slice(3, 6).join(""), '-', matchParts.slice(6, 10).join("")].join('')
      return result
    }
    catch {
      return str;
    }
  }

  return str
}

export const replacePhoneNumbers = (text: string) => {
  const phoneRegex = new RegExp(
    /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/gim
  )

  let renderText = () => {
    let match = text.match(phoneRegex)
    if (match && match?.length > 0) {
      let parts: any[] = text.split(phoneRegex)
      parts.splice(1, 0, <a href={`tel:${formatPhoneNumber(match[0])}`}>{formatPhoneNumber(match[0])}</a>)
      return parts
    }
    else {
      return text
    }

  }
  return renderText()
}
